(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('MarketPrice', MarketPrice);

    MarketPrice.$inject = ['$resource', 'DateUtils'];

    function MarketPrice ($resource, DateUtils) {
        var resourceUrl =  'api/marketPrices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST'}
        });
    }
})();
